const LOGIN_PENDING: string = 'LOGIN_PENDING'
const LOGIN_SUCCESS: string = 'LOGIN_SUCCESS'
const LOGIN_ERROR: string = 'LOGIN_ERROR'

export { LOGIN_PENDING, LOGIN_SUCCESS, LOGIN_ERROR }